export default __webpack_public_path__ + "static/media/IMG_0012.819ccf0d.MP4";